import {EntityList} from '@/types/Entity'
import {CONSTANTS} from '@/types/enum/constants'

export const getFrontOfficeConsultContract: any[] = [
    {
        route: 'ListContractInsight',
        text: 'Liste des contrats Insight',
        href: '/frontoffice/consult/contract',
        home: true,
        menuHeader: true,
    },
    {
        route: 'ListContractSound',
        text: 'Liste des contrats Sound',
        href: '/frontoffice/consult/contract-sound',
        menuHeader: true,
    },
].map(route => ({
    ...route,
    entity: [EntityList.PHARMEDIGROUP],
    roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_CONSULT_CONTRACT_USER],
}))
